'use client'

import clsx from 'clsx'

import Section from '/react4xp/components/Section'
import Breadcrumbs from '/react4xp/components/Breadcrumbs'
import HighlightedPublication, { HighlightPublicationData } from '/react4xp/components/HighlightedPublication'

import './index.scss'

interface PublicationProps {
    className?: string
    breadcrumbs?: {
        label: string
        url?: string
    }[]
    highlightPublicationData?: HighlightPublicationData
}

export default function Publication({
    className,
    breadcrumbs,
    highlightPublicationData
}: PublicationProps) {
    const hasBreadcrumbs = breadcrumbs && breadcrumbs.length > 0

    return (
        <div className={clsx('page-publication', className)}>
            {hasBreadcrumbs && (
                <Section>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3'>
                                <Breadcrumbs items={breadcrumbs} />
                            </div>
                        </div>
                    </div>
                </Section>
            )}

            {highlightPublicationData && (
                <Section>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <HighlightedPublication
                                    highlightPublicationData={highlightPublicationData}
                                    titleAsH1
                                />
                            </div>
                        </div>
                    </div>
                </Section>
            )}
        </div>
    )
}
